import type { CSSProperties } from 'react';

import classnames from 'classnames';

import type { Preference } from '@/types';

import { input, labelStyle } from './AdditionalFields.css';

interface Props {
  style: CSSProperties;
  preference: Preference;
  type?: string;
  isLabelVisible?: boolean;
}

const TextInput = ({ style, preference, type, isLabelVisible }: Props) => {
  return (
    <div className="flex flex-col gap-1">
      {isLabelVisible && (
        <label className={classnames(labelStyle, 'w-full')} htmlFor={`preference_${preference?.id}`}>
          {preference?.name}
          {preference?.required && <span>*</span>}
        </label>
      )}
      <input
        className={classnames(input, 'w-full cursor-text pl-4')}
        style={style}
        name={preference?.name_override || `field_${preference?.custom_field_id}`}
        required={preference?.required}
        type={type}
        {...(type === 'tel' ? { pattern: '^d{3}[-.s]?d{3}[-.s]?d{4}$' } : {})}
        placeholder={preference?.placeholder || preference?.name || ''}
        id={`preference_${preference?.id}`}
      />
    </div>
  );
};

export default TextInput;
